
let variantChosen

function initVariants(){
  const variantJson = document.querySelector('[data-variant-json]');

  if (!variantJson) {
    return;
  }

  let options = {}
  let variantsObject = JSON.parse(variantJson.innerHTML); 
  const variantWrappers = document.querySelectorAll('.variant-wrapper')
  getSelectOptions()
  disableNonStock()

  function checkIfInStock(){   
    if (options.option1 == undefined) {
      options.option3 = null
    }

    if (options.option2 == undefined) {
      options.option3 = null
    }

    if (options.option3 == undefined) {
      options.option3 = null
    }   

    variantsObject.forEach((jsonOption) => {

      if (jsonOption.option1 == options.option1 && jsonOption.option2 == options.option2 && jsonOption.option3 == options.option3) {

        if (jsonOption.inventory_quantity < 1) {
          document.querySelector('.js-buy').innerHTML = "Out of stock"
       }else{
          document.querySelector('.js-buy').innerHTML = "Add to cart"
          document.querySelector('.js-buy').setAttribute('data-id', jsonOption.id)
          variantChosen = jsonOption
        }
      }
    })
  }



  function disableNonStock(input){
    let chosenInput
    let chosenValue

    variantWrappers[0].querySelectorAll('input').forEach((input) => {
      if (input.checked) {
        chosenInput = input.getAttribute('data-index')
        chosenValue = input.getAttribute('value')
      }
    })

    variantWrappers[1].querySelectorAll('input').forEach((variant) => {
      let optionNum = variant.getAttribute('data-index')
      let optionValue = variant.getAttribute('value')  

      variantsObject.forEach((jsonOption) => {    

        if (jsonOption[optionNum] == optionValue && jsonOption[chosenInput] == chosenValue ) {

          if (jsonOption.inventory_quantity < 1) {
            variant.parentElement.classList.add('disabled')
          }else{
            variant.parentElement.classList.remove('disabled')
          }
        }   
      }) 
    })    
  }

  function getSelectOptions(){
    variantWrappers.forEach((wrap) => {  
      wrap.querySelectorAll('input').forEach((variant) => {
        variant.parentElement.classList.remove('checked')
        if (variant.checked) {
          variant.parentElement.classList.add('checked')
          let optionNum = variant.getAttribute('data-index')
          let otionValue = variant.getAttribute('value')
          options[optionNum] = otionValue
          checkIfInStock()        
        }
      })
    })
  }

  variantWrappers.forEach((wrap) => {  
    wrap.querySelectorAll('input').forEach((variant) => {
      variant.addEventListener('change', () =>{
        getSelectOptions()
        disableNonStock(variant)      
        document.querySelector('.qty-selector__input').value = 1;
        document.querySelector('.js-buy').style.display = "block"
        document.querySelector('.buy-btn-flipped').style.display = "none"

      })
    })
  })
}

function initBuyBtn(){
  const btn = document.querySelector('.js-buy')

  btn.addEventListener('click', function(){
    const url = `/cart/add.js`;
    data = []  
    let id = document.querySelector('.js-buy').getAttribute('data-id')
    let qty = document.querySelector('.js-buy').getAttribute('data-qty')
    data.push({id: id, quantity: qty})

    const payload = {"items" : data }  


    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
    .then((response) => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response;
    })
    .then((response) => response.json())
    .then((data) => {
      handleResponse(data);
    })
    .catch((error) => {
      console.error(error); 
    });

    function handleResponse(data){
      console.log(data);
      console.log('updtaed with items!');  
      btn.style.display = "none"
      document.querySelector('.buy-btn-flipped').style.display = "flex"
      updateCart()
    }
  })

  document.querySelector('.go-back').addEventListener('click', (e) => {
    console.log('clicked');
    e.preventDefault()
    window.history.go(-1)
  })
}

function initQtySelector(){
  const plus = document.querySelector('.js-plus')
  const minus = document.querySelector('.js-minus')
  const input = document.querySelector('.qty-selector__input')

  input.addEventListener('change', () => {

    if (parseInt(input.value) + 1 > variantChosen.inventory_quantity) {
      alert(`sorry - only ${variantChosen.inventory_quantity} ${variantChosen.name} in stock!`)
      input.value = variantChosen.inventory_quantity
      document.querySelector('.js-buy').setAttribute('data-qty', variantChosen.inventory_quantity)
      return;
    }

    document.querySelector('.js-buy').setAttribute('data-qty', parseInt(input.value))
  })

  plus.addEventListener('click', () => {
    console.log(variantChosen.inventory_quantity);

    if (parseInt(input.value) + 1 > variantChosen.inventory_quantity) {
      alert(`sorry - only ${variantChosen.inventory_quantity} ${variantChosen.name} in stock!`)
      return;
    }

    let current =  parseInt(input.value) + 1    
    input.value = current
    document.querySelector('.js-buy').setAttribute('data-qty', current)
  })

  minus.addEventListener('click', () => {

    if (input.value > 1) {

      console.log(variantChosen);
      let current =  parseInt(input.value) - 1    
      input.value = current
      document.querySelector('.js-buy').setAttribute('data-qty', current)
    }
    
  })

}

function updateCart(){



  const url = `/cart.js`;





  fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    }
  })
  .then((response) => {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response;
  })
  .then((response) => response.json())
  .then((data) => {
    handleResponse(data);
  })
  .catch((error) => {
    console.error(error); 
  });

  function handleResponse(data){
    console.log(data.item_count);
    document.querySelector('.cart-count').innerHTML = data.item_count
    document.querySelector('.cart-count').classList.remove('hidden-count')
  }
}



initVariants()
initBuyBtn()
initQtySelector()